// 全局的列表处理方式
import {
  listData,
  listMethods
} from "./globalList";
/**
 * @name 报名等按钮枚举
 */
const ButtonSubmitEnum = {
  1: {
    remarks: '我要报名',
    methodsName: 'enlist',
    executeStatement: '',
    serviceFeeType: '01'
  },
  2: {
    remarks: '再次报名',
    methodsName: 'enlist',
    executeStatement: '',
    serviceFeeType: '01'
  },
  3: {
    remarks: '我要报名&报价',
    methodsName: 'easyTender',
    executeStatement: '',
    serviceFeeType: '01'
  },
  4: {
    remarks: '再次报名&报价',
    methodsName: 'easyTender',
    executeStatement: '',
    serviceFeeType: '01'
  },
  5: {
    remarks: '申请报名',
    methodsName: 'applySignUp',
    executeStatement: '',
    serviceFeeType: '01'
  },
  6: {
    remarks: '申请报名&报价',
    methodsName: 'applySignUp',
    executeStatement: '',
    serviceFeeType: '01'
  },
  7: {
    remarks: '我要投标',
    methodsName: 'tender',
    executeStatement: ''
  },
  8: {
    remarks: '再次投标',
    methodsName: 'tender',
    executeStatement: ''
  },
  9: {
    remarks: '业主查询',
    methodsName: 'ownerQuery'
  },
  10: {
	remarks: '我要竞价',
	methodsName: '',
	serviceFeeType: '02'
  },
  'CHECK_NEED_TO_PAY_SERVICE_FEE': {
    remarks: '需要缴纳服务费',
    methodsName: 'getServicePrice',
    executeStatement: 'this.$refs.serviceCharge.serviceChargeDisplay = true'
  },
  'CHECK_NEED_TO_PAY_VIP_FEE': {
    remarks: '需要缴纳会员费',
    methodsName: 'informServicePrice',
    executeStatement: '',
    hasSetMeal: false
  },
  'CHECK_NEED_TO_PAY_MEMBERSHIP_FEE': {
    remarks: '需要缴纳会员费',
    methodsName: 'informServicePrice',
    executeStatement: '',
    hasSetMeal: true
  },
  'PAYMENT_EARNEST_MONEY': {
    remarks: '需要缴纳质保金',
    methodsName: '',
    executeStatement: 'this.$refs.marginPopUp.showMarginPopUp = true'
  }
}
export default {
  data() {
    return {
      ButtonSubmitEnum,
      ...listData
    }
  },
  methods: {
    ...listMethods
  }
}